import ExaHelpers from "../exa_helpers";
import Fuse from "fuse.js";

export default class CandidateAdd {

    constructor() {
        window["CandidateAdd"] = this;
        this.init();
    }


    init() {


        ExaHelpers.validation();
        this.initValidation();

    }


    initValidation() {
        

        $('.js-validation').validate({
            ignore: "[contenteditable='true']:not([name])",
            rules: {
                'gender_id': {
                    required: true,
                },
                'first_name': {
                    required: true,
                },
                'last_name': {
                    required: true,
                },              
                'email': {
                    required: true,
                    email: true,
                },
                'mobile_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'password': {
                    required: true,
                },               
            },
        });

        
    }




}